import type { FC, SVGProps } from 'react';

export const OrbitOneNavIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <line
      x1='5.1'
      y1='8'
      x2='3.22'
      y2='8'
      stroke='currentColor'
      strokeWidth='0.5'
      strokeLinecap='round'
    />
    <circle cx='2' cy='8' r='1.96' fill='currentColor' opacity='0.35' />
    <circle cx='2' cy='8' r='1.22' fill='currentColor' />
    <line
      x1='10.9'
      y1='8'
      x2='12.78'
      y2='8'
      stroke='currentColor'
      strokeWidth='0.5'
      strokeLinecap='round'
    />
    <circle cx='14' cy='8' r='1.96' fill='currentColor' opacity='0.35' />
    <circle cx='14' cy='8' r='1.22' fill='currentColor' />
    <circle cx='8' cy='8' r='3.65' fill='currentColor' opacity='0.15' />
    <circle cx='8' cy='8' r='3.2' stroke='currentColor' strokeWidth='0.75' fill='none' />
    <circle cx='8' cy='6.5' r='1.35' fill='currentColor' opacity='0.2' />
    <circle cx='8' cy='6.5' r='1.1' stroke='currentColor' strokeWidth='0.25' fill='none' />
    <circle cx='8' cy='6.5' r='0.72' fill='currentColor' opacity='0.45' />
    <circle cx='7.6' cy='6.05' r='0.32' fill='currentColor' opacity='0.55' />
    <circle cx='8.35' cy='6.85' r='0.22' fill='currentColor' opacity='0.45' />
    <circle cx='8' cy='9.5' r='1.35' fill='currentColor' opacity='0.2' />
    <circle cx='8' cy='9.5' r='1.1' stroke='currentColor' strokeWidth='0.25' fill='none' />
    <circle cx='8' cy='9.5' r='0.72' fill='currentColor' opacity='0.45' />
    <circle cx='7.6' cy='9.05' r='0.32' fill='currentColor' opacity='0.55' />
    <circle cx='8.35' cy='9.85' r='0.22' fill='currentColor' opacity='0.45' />
    <circle cx='5.6' cy='6.35' r='0.38' fill='currentColor' opacity='0.5' />
    <circle cx='10.4' cy='6.35' r='0.38' fill='currentColor' opacity='0.5' />
    <circle cx='5.6' cy='9.65' r='0.38' fill='currentColor' opacity='0.5' />
    <circle cx='10.4' cy='9.65' r='0.38' fill='currentColor' opacity='0.5' />
    <line
      x1='8'
      y1='4.35'
      x2='8'
      y2='1.55'
      stroke='currentColor'
      strokeWidth='0.75'
      strokeLinecap='round'
    />
    <circle cx='8' cy='3.95' r='0.52' stroke='currentColor' strokeWidth='0.75' fill='none' />
    <rect x='7.55' y='1.1' width='0.9' height='0.72' rx='0.2' fill='currentColor' opacity='0.55' />
  </svg>
);
